import styled, { css } from "styled-components";
import { Theme } from "@material-ui/core/styles";

export interface DataTableProps {
  horizontal?: boolean;
}

const DataTable = styled.div<DataTableProps>`
  max-width: 100%;

  ${({ horizontal }) =>
    horizontal &&
    `
  th {
    text-align: left;
  }
  `}

  ${(props) => {
    const horizontal = props.horizontal;
    const theme = props.theme as any as Theme;

    return css`
      table tbody + tbody > tr:first-child td,
      table tbody + tbody > tr:first-child th,
      table thead tr:first-child {
        border-top: 1px solid ${theme.palette.divider};
      }

      table thead tr:last-child,
      table thead + tbody tr:last-child {
        border-bottom: 1px solid ${theme.palette.divider};
      }

      table td {
        vertical-align: top;
      }

      table thead th {
        text-align: left;
        vertical-align: bottom;
        position: sticky;
        top: 0;
        background-color: white;
        border-bottom: 1px solid ${theme.palette.divider};
      }

      ${
        !horizontal &&
        css`
          table thead > tr {
            position: sticky;
            top: 56px;
          }
        `
      }

      ${theme.breakpoints.up("sm")} {
        ${
          !horizontal &&
          css`
            table thead > tr {
              top: 64px;
            }
          `
        }

      table tbody th {
        vertical-align: top;
      }

      table tbody tr:nth-child(2n + 1) {
        background-color: white;
      }

      table tbody tr:nth-child(2n) {
        background-color: ${theme.palette.grey[100]};
      }

      table {
        border-collapse: collapse;
      }

      table th,
      table td {
        padding: 0.25em 0.5em;
      }

      table td a {
        word-break: normal;
      }`;
  }}
`;

export default DataTable;
